<template>
  <div>
    <div v-if="!isPC" class="mobile-header f-b-c">
      <div class="mobile-header-left f--c">
        <i class="iconfont icon-menu-fill" @click="menuShowForMobile = true"></i>
        <img class="mobile-logo" src="@/assets/img/mobile-logo.jpg" @click="$router.push('/home')" />
      </div>
      <div class="mobile-header-right f-c-c">
        <i v-if="!['/mall', '/', '/mall/search'].includes($route.path)" class="iconfont icon-a-search-line1" @click="$router.push('/mall/search')"></i>
        <i class="iconfont icon-fenlei" @click="$refs.productMenu.show()"></i>
      </div>
      <van-popup v-model="menuShowForMobile" position="left" :style="{ width: '60%', height: '100%' }" closeable close-icon-position="top-left">
        <div class="navigationContent">
          <div class="user">
            <template v-if="$store.state.common.userName">
              <van-icon name="user-o" />
              <span style="margin-left: 0.3rem">{{ $store.state.common.userName }}</span>
            </template>
            <el-button v-else style="width: 100%" type="primary" @click="navigageClick({ path: '/login', event_id: '505' })">{{ $t('headerBar.login') }}</el-button>
          </div>
          <div class="navigate f fw-w" style="margin-top: 0.1rem">
            <div v-for="t in navigate" :key="t.path" @click="navigageClick(t)" :class="{ activeM: routerPath === t.path }" style="width: 100%">
              {{ $t(t.title) }}
              <img v-if="t.type && t.type === 'hot'" class="hot" src="@/assets/img/icon/new.svg" alt="" lazy />
            </div>
            <div @click="navigageClick({path: '/blog'})" style="width: 100%">
              {{ $t('headerBar.blog') }}
            </div>
            <br />
          </div>
          <!-- <van-collapse v-model="homeActiveForMobile" class="myCompany">
            <van-collapse-item :title="$t('headerBar.home')" name="1">
              <div v-for="t in navigate" :key="t.path" class="itemContent" @click="navigageClick(t)" :class="{ activeM: routerPath === t.path }">{{ $t(t.title) }}</div>
            </van-collapse-item>
          </van-collapse>
          <template v-if="$store.state.common.userName">
            <div class="navigate f fw-w" style="margin-top: .1rem">
              <div @click="navigageClick({ path: '/publish/productList', event_id: '507'})" :class="{ activeM: routerPath === '/publish/productList' }" style="width: 100%">{{$t('headerBar.wishList')}}</div><br>
              <div @click="navigageClick({ path: '/publish/listings', event_id: '508'})" :class="{ activeM: routerPath === '/publish/listings' }" style="width: 100%">{{$t('headerBar.listing')}}</div><br>
              <div @click="navigageClick({ path: '/order/list', event_id: '509'})" :class="{ activeM: routerPath === '/order/list' }" style="width: 100%">{{$t('headerBar.allOrder')}}</div><br>
            </div>
          </template> -->
          <div v-if="$store.state.common.userId" class="logout f-c-c" @click="logOut">
            {{ $t('headerBar.logOut') }}
          </div>
        </div>
      </van-popup>
      <ProductMenu ref="productMenu"></ProductMenu>
    </div>

    <div v-else :class="['header', 'f--c', 'fixed', { 'change-bg-color': isChangeBgColor },{'header-background':$route.path.indexOf('/home')>-1}]">
      <div class="navigate f-b-c">
        <div class="left f--c">
          <div class="img pointer" @click="$router.push('/home')"><img src="@/assets/img/logo.png" /></div>
          <div class="menu">
            <div v-for="t in navigate" :key="t.title" class="item pointer" :class="{ active: routerPath === t.path }" :style="{ width: t.title == 'Kaka AI' ? '80px' : null, minWidth: t.title == 'Kaka AI' ? '80px' : null }" @click="handleActive(t)">
              <span>{{ $t(t.title) }}</span>
              <img v-if="t.type && t.type === 'hot'" class="hot" src="@/assets/img/icon/new.svg" alt="" lazy />
            </div>
            <div class="item pointer" @click="handleActive({path: '/blog'})">
              <span>{{ $t('headerBar.blog') }}</span>
            </div>
          </div>
        </div>
        <el-dropdown v-if="$store.state.common.userName" @command="handleCommand">
          <span class="el-dropdown-link f-c-c">
            <div class="avatar f-c-c">{{ firstName }}</div>
            <div class="ellipsis" style="max-width: 100px">{{ $store.state.common.userName }}</div>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="1">{{ $t('headerBar.wishList') }}</el-dropdown-item>
            <el-dropdown-item :command="2">{{ $t('headerBar.listing') }}</el-dropdown-item>
            <el-dropdown-item :command="3">{{ $t('headerBar.allOrder') }}</el-dropdown-item>
            <el-dropdown-item :command="4">{{ $t('Home.Components.HomeHead.PersonalCenter') }}</el-dropdown-item>
            <el-dropdown-item :command="5">{{ $t('headerBar.logOut') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div v-else class="f--c">
          <div class="login pointer" @click="jump('/login', 505)">{{ $t('headerBar.login') }}</div>
          <div class="register f-c-c pointer" @click="jump('/register', 506)">{{ $t('headerBar.register') }}</div>
        </div>
      </div>
    </div>
    <!-- 站内信 新功能查看 -->
    <new-function v-if="$store.state.common.userName" ref="newFunction" />
    <!-- 购物车 -->
    <shopping-cart ref="shoppingCart" />
    <whats-app :bottom="160" />
  </div>
</template>

<script>
import API from '@/api'
import newFunction from '@/components/newFunction.vue'
import ShoppingCart from '@/components/ShoppingCart.vue'
import icon from 'vant/lib/icon'
import 'vant/lib/icon/style'
import popup from 'vant/lib/popup'
import 'vant/lib/popup/style'
// import Collapse from 'vant/lib/collapse'
import 'vant/lib/collapse/style'
// import CollapseItem from 'vant/lib/collapse-item'
import 'vant/lib/collapse-item/style'
import TreeSelect from 'vant/lib/tree-select'
import 'vant/lib/tree-select/style'
import bus from '@/util/bus'
// import { sharingLogin } from '@/util/cookie'
import WhatsApp from '../../../components/WhatsApp.vue'
import ProductMenu from '../../../components/mobile/ProductMenu.vue'

export default {
  data() {
    return {
      input: undefined,
      navigate: [
        { title: 'headerBar.startSelling', path: '/mall', event_id: 500 },
        { title: 'headerBar.dropshipping', path: '/dropshipping', event_id: 501 },
        { title: 'indexPage.customization', path: '/service', event_id: 502 },
        // { title: 'headerBar.fashionTrends', path: '/mall/explore', event_id: 53, type: 'hot' },
        // { title: 'Kaka AI', path: '/ai', event_id: 53, type: 'hot' },
        { title: 'Print On Demand', path: '/pod' },
        { title: 'headerBar.helpCenter', path: '/help-center', event_id: 504 }
      ],
      menuShowForMobile: false,
      homeActiveForMobile: ['1'],
      categoryVisibleForMobile: false,
      categoryTreeActive: 0,
      categoryTreeOptions: [{ text: '分组 1' }, { text: '分组 2' }],

      isChangeBgColor: false // 是否改变北京颜色
    }
  },
  components: {
    newFunction,
    ShoppingCart,
    'van-icon': icon,
    'van-popup': popup,
    // 'van-collapse': Collapse,
    // 'van-collapse-item': CollapseItem,
    'van-tree-select': TreeSelect,
    WhatsApp,
    ProductMenu
  },
  computed: {
    routerPath() {
      return this.$route.path
    },
    firstName() {
      return this.$store.state.common.userName && this.$store.state.common.userName[0].toUpperCase()
    },
    isShowAdvertis() {
      return this.$store.state.isShowAdvertis
    },
    categoryTree() {
      const categoryTree = this.$store.state.common.categoryTree
      if (categoryTree.length === 0) this.$store.dispatch('common/getCategoryTree')
      categoryTree.forEach((e) => {
        e.text = e.name
        if (e.childList) {
          e.childList.forEach((ee) => (ee.text = ee.name))
        }
      })
      return categoryTree
    },
    categoryTreeActiveTree() {
      const target = this.categoryTree[this.categoryTreeActive] || { childList: [] }
      return target.childList
    }
  },
  created() { },
  mounted() {
    window.addEventListener('scroll', this.getScrollx, true)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.getScrollx, true)
  },
  methods: {
    getScrollx() {
      if (window.pageYOffset > 0) {
        this.isChangeBgColor = true
      } else {
        this.isChangeBgColor = false
      }
    },

    customSearch(searchText) {
      if (searchText === '') return
      this.$router.push({
        path: '/product-list',
        query: {
          search: searchText
        }
      })
    },
    handleActive(t) {
      if (['/mall', '/mall/explore'].includes(t.path)) {
        // sharingLogin()
        window.open(process.env.VUE_APP_MAIN_DOMAIN + t.path)
        return
      }
      if (t.path === '/blog') {
        // window.open('https://blog.kakaclo.com', '_blank')
        window.open('https://www.kakaclo.com/wp-blog', '_blank')
        return
      }
      t.path && this.$router.push(t.path)
    },
    handleMenu(t) {
      t.path && this.$router.push(t.path)
    },
    handleCommand(command) {
      switch (command) {
        case 1:
          this.$router.push('/publish/productList')
          return
        case 2:
          this.$router.push('/publish/listings')
          return
        case 3:
          this.$router.push('/order/list')
          return
        case 4:
          this.$router.push('/personal-center/account-setting')
          return
        case 5:
          this.logOut()
      }
    },
    handleCompanyCommand(command) {
      this.$router.push(command)
    },
    logOut() {
      API.logout().finally(() => {
        this.$store.dispatch('logOut')
      })
    },
    showNewFunction() {
      this.$refs.newFunction.show()
    },
    showShoppingCart() {
      this.$refs.shoppingCart.show()
    },
    navigageClick(t) {
      this.menuShowForMobile = false
      if (['/mall', '/mall/explore'].includes(t.path)) {
        // sharingLogin()
        window.open(process.env.VUE_APP_MAIN_DOMAIN + t.path)
        return
      }
      if (t.path === '/blog') {
        window.open('https://www.kakaclo.com/wp-blog', '_blank')
        return
      }
      this.$router.push(t.path)
    },
    showUploadPopout() {
      this.$refs.uploadPopout.show()
    },
    jump(path, event_id) {
      this.$router.push({ path })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  font-family: 'Poppins', 'PingFang SC', 'Sen', 'Helvetica', 'Arial',
    'Sans-serif' !important;

  .hot {
    width: 28px;
    height: 16px;
    position: absolute;
    top: -3px;
    right: -8px !important;
  }
  font-family: 'Poppins', 'PingFang SC', 'Sen', 'Helvetica', 'Arial',
    'Sans-serif';
  width: 100%;
  background: #fbfbf8;
  flex-direction: column;
  transition: all 0.5s;
  // box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);

  .navigate {
    max-width: 1400px;
    min-width: 1000px;
    width: 100%;
    padding: 0 15px;
    height: 80px;
    .img {
      margin-right: 46px;
      img {
        height: 40px;
      }
    }

    .left {
      height: 100%;
      .menu {
        height: 100%;
        display: flex;
        align-items: flex-end;
      }
      .item {
        flex-shrink: 0;
        height: 53px;
        margin-right: 26px;
        color: #121e26;
        font-weight: 500;
        padding-top: 6px;
        position: relative;
        &:nth-child(1) {
          width: 95px;
          min-width: 95px;
        }
        &:nth-child(2) {
          width: 104px;
          min-width: 104px;
        }
        &:nth-child(3) {
          width: 111px;
          min-width: 111px;
        }
        &:nth-child(4) {
          width: 134px;
          min-width: 134px;
        }
        &:nth-child(5) {
          width: 94px;
          min-width: 94px;
        }
      }
      .item:hover {
        color: #86b817;
        font-weight: 600;
      }
      .active {
        border-bottom: 4px solid #000;
        color: #000;
        font-size: 16px;
      }
      .hot {
        width: 28px;
        height: 16px;
        position: absolute;
        top: -5px;
        right: -24px;
      }
    }
    .login {
      display: inline-block;
      width: 50px;
      min-width: 50px;
    }
    .avatar {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: #99c41c;
      color: #fff;
      font-size: 14px;
      margin-right: 10px;
    }
    .register {
      height: 40px;
      width: 150px;
      min-width: 150px;
      margin-left: 0.5vw;
      border-radius: 4px;
      background-color: #99c41c;
      color: #fff;
      margin-left: 30px;
    }
  }
}
.header-background {
  background-image: url('https://img.kakaclo.com/web-img/home/home2.0/Slice%202539.png?x-oss-process=image/resize,w_1920,h_1080,m_fill/format,webp');
  background-repeat: no-repeat;
  background-size: 100%;
}

.change-bg-color {
  background-image: none;
  background-color: #fff !important;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.5s;
}

.fixed {
  position: fixed;
  z-index: 1000;
}
.blog-item {
  color: #606266;
  font-size: 14px;
  text-decoration: none;
  display: inline-block;
  width: 100%;
}
.blog-item:hover {
  color: #99c41c;
}
.mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100vw;
  height: 0.86rem;
  padding: 0 0.3rem;
  background: white;
  z-index: 1999;
  .icon-menu-fill {
    font-size: 0.46rem;
    margin-right: 0.22rem;
  }
  .mobile-logo {
    width: 2.07rem;
    height: 0.45rem;
  }
  .mobile-header-right {
    .icon-a-search-line1 {
      font-size: 0.42rem;
      margin-right: 0.2rem;
    }
    .mobile-cart-num {
      position: absolute;
      top: -0.12rem;
      left: 0.25rem;
      background: #ab1e1a;
      line-height: 0.2rem;
      text-align: center;
      border-radius: 10px;
      color: white;
      padding: 0.02rem 0.05rem;
      font-size: 0.24rem;
    }
    .icon-shangpin-gouwudai {
      font-size: 0.4rem;
    }
    .icon-fenlei {
      font-size: 0.48rem;
      margin-left: 0.2rem;
    }
  }
  .navigationContent {
    // padding-top: 60px;
    // padding-bottom: 1.5rem;
    position: relative;
    min-height: 100vh;
    .user {
      padding: 0 0.3rem;
      font-weight: bold;
      // margin-bottom: 0.5rem;
      padding-top: 1rem;
      /deep/.van-icon {
        font-size: 0.4rem;
        font-weight: bold;
      }
    }
    .navigate {
      padding: 0 0.3rem;
      > div {
        font-weight: bold;
        padding: 0.2rem 0.2rem 0.2rem 0;
        width: 50%;
        margin-bottom: 0.2rem;
        border-bottom: 1px solid transparent;
        font-size: 0.25rem;
      }
      .activeM {
        border-bottom: 2px solid #000;
        color: #000;
      }
    }
    .myCompany {
      .itemContent {
        padding: 0.1rem 0.3rem;
        border-bottom: 2px solid transparent;
      }
      .activeM {
        border-bottom: 2px solid #000;
        color: #000;
      }
      /deep/.van-cell__title {
        font-weight: bold;
      }
    }
    .logout {
      width: 3rem;
      height: 0.7rem;
      border: 1px solid #b6b6b6;
      color: #b6b6b6;
      font-size: 0.28rem;
      position: absolute;
      bottom: 0.6rem;
      left: 0;
      right: 0;
      margin: auto;
      border-radius: 0.12rem;
    }
    /deep/.van-hairline--top-bottom::after {
      border: none !important;
    }
    /deep/.van-hairline-unset--top-bottom::after {
      border: none !important;
    }
  }
}

.mobileHeader {
  background-color: #fff;
  padding: 0.1rem 0.3rem;
  font-size: 0.4rem;
}
</style>
